/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-12-06 17:18:37
 * @LastEditTime: 2021-12-06 17:36:29
 * @LastEditors: 赵大壮
 */
import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceInfo from "@/views/资讯管理/service/DZServiceInfo";
import DZModelPage from "@/model/DZModelPage";
import nyMessageToast from "@/utils/NYMessageToast";
import DZModelInfoType from "@/views/资讯管理/model/DZModelInfoType";
import dzMsgBox from "@/utils/DZMessageBox";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    is_dialog_show = false;

    is_edit = false;

    m_page = new DZModelPage(10);

    s_info = new DZServiceInfo();

    key_name = "";

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    dialog_init(){
        this.s_info.m_type = new DZModelInfoType();
    }

    dialog_close(){
        this.is_dialog_show = false
        this.dialog_init()
    }
    /**
     * 查
     */
    action_list_data(){
        this.s_info.net_page_type(this.s_info.m_search)
    }
    action_page_change(cur_page){
        this.s_info.m_search.pageNum = cur_page;
        this.action_list_data();
    }
    /**
     * 增
     */
    action_open_dialog(){
        this.is_edit = false
        this.is_dialog_show = true
    }
    action_add_type(){
        if(this.s_info.m_type.name.nyIsEmpty()){
            nyMessageToast.warning("请输入分类名称");
            return;
        }
        this.s_info.net_add_type(this.action_list_data)
        this.dialog_close()
    }

    /**
     * 改
     * @param row
     */
    handle_edit(row){
        this.is_edit = true
        this.s_info.m_type = Object.assign({},row)
        this.is_dialog_show = true
    }
    action_edit_type(){
        if(this.s_info.m_type.name.nyIsEmpty()){
            nyMessageToast.warning("请输入分类名称");
            return;
        }
        this.s_info.net_edit_type(this.action_list_data)
        this.dialog_close();
    }

    /**
     * 删
     */
    action_delete_type(row){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_info.net_delete_type(row.id,() => {
                this.action_list_data()
            });
        })
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit(row)
        }
    }
    handleSizeChange(val){
        this.s_info.m_search.pageSize = val
        this.action_list_data()
    }
}
